import React from "react";
import { useTranslate } from "react-admin";

import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import GetAppIcon from "@material-ui/icons/GetApp";

import { httpClient } from "../../api/httpClient";
import { downloadByNavigation } from "../../utils/download";
import { useNotifyError } from "../../utils/notifiers/useNotifyError";

const useStyles = makeStyles((theme) => ({
	card: { maxWidth: 480, marginTop: theme.spacing(2) },
	row: { marginBottom: theme.spacing(1) },
	download: { marginTop: theme.spacing(1) },
	hint: { marginTop: theme.spacing(2), color: theme.palette.text.secondary },
}));

export const MobileAppPage = () => {
	const translate = useTranslate();
	const notifyError = useNotifyError();
	const classes = useStyles();

	const [result, setResult] = React.useState({ status: "loading" });

	React.useEffect(() => {
		let cancelled = false;
		httpClient("/mobile-app/employee/info")
			.then(({ json }) => {
				if (!cancelled) setResult({ status: "ready", appInfo: json });
			})
			.catch((error) => {
				if (cancelled) return;
				if (error.status === 404) {
					setResult({ status: "not_uploaded" });
				} else {
					notifyError(error);
					setResult({ status: "failed" });
				}
			});
		return () => {
			cancelled = true;
		};
	}, [notifyError]);

	const download = async () => {
		// An expired session or removed APK would navigate the SPA to a raw
		// JSON error body — pre-check and notify instead
		try {
			await httpClient("/mobile-app/employee/info");
		} catch (error) {
			notifyError(error);
			return;
		}
		downloadByNavigation("/mobile-app/employee/latest");
	};

	return (
		<Card className={classes.card}>
			<CardContent>
				<Typography variant="h5" className={classes.row}>
					Sealog Employee
				</Typography>
				{result.status === "loading" && <CircularProgress />}
				{result.status === "ready" && (
					<>
						<Typography className={classes.row}>
							{`${translate("pages.mobile-app.version")}: ${result.appInfo.version}`}
						</Typography>
						<Typography className={classes.row}>
							{`${translate("pages.mobile-app.released")}: ${new Date(
								result.appInfo.uploaded_at
							).toLocaleDateString()}`}
						</Typography>
						<Button
							variant="contained"
							color="primary"
							startIcon={<GetAppIcon />}
							onClick={download}
							className={classes.download}
						>
							{translate("pages.mobile-app.download")}
						</Button>
						<Typography variant="body2" className={classes.hint}>
							{translate("pages.mobile-app.install_hint")}
						</Typography>
					</>
				)}
				{result.status === "not_uploaded" && (
					<Typography>{translate("pages.mobile-app.not_available")}</Typography>
				)}
				{result.status === "failed" && (
					<Typography>{translate("ra.notification.http_error")}</Typography>
				)}
			</CardContent>
		</Card>
	);
};
